export default "__VITE_ASSET__wQ2$Yq$B__"